/*******************************************************************************
Insert Connatix Ads
Add Connatix ads to articles and lineup pages
*******************************************************************************/

function getSTNPlayerCode(){
    return `<div class='s2nPlayer-3bcVtUw6' data-type='full'></div><script type='text/javascript' src='//embed.sendtonews.com/player2/embedcode.php?fk=3bcVtUw6&cid=13664' data-type='s2nScript'></script>`;
}

// Add a connatix ad in the set of lineups making sure to have some space between the existing 300x250 ad
function addLineupCardPlacements() {
    const stnPlayerCode = getSTNPlayerCode();

    // Add CSS to make the ad take up the full width of the container
    document.head.appendChild(document.createElement("style")).innerHTML = ".lineup.is-ad.is-connatix > div[data-stn-player] { min-width: 100%; }";

    if ($('.lineup:not(.hide):not(.is-tools)').length >= 5 && $('.is-connatix').length === 0) {
        let connatixAdSlot = 3;
        const numHiddenLineups = $('.lineup.hide').length;
        if (numHiddenLineups > 0) {
            const ad300Position = $('.lineup.is-ad').index();
            const numVisibleLineups = $('.lineup:not(.hide):not(.is-tools)').length;
            connatixAdSlot = numHiddenLineups > ad300Position ? numHiddenLineups + 2 : ad300Position + 2;
            connatixAdSlot = Math.min(numVisibleLineups - 1, connatixAdSlot);
        }
        $(`.lineup:nth-child(${connatixAdSlot})`).after(`<div class="lineup is-ad is-connatix">${stnPlayerCode}</div>`);
    }

    if ($('.lineup:not(.hide):not(.is-tools)').length >= 10 && $('.is-connatix').length === 1) {
        let connatixAdSlot = 9;
        const numHiddenLineups = $('.lineup.hide').length;
        if (numHiddenLineups > 0) {
            const ad300Position = $('.lineup.is-ad').index();
            const numVisibleLineups = $('.lineup:not(.hide):not(.is-tools)').length;
            connatixAdSlot = numHiddenLineups > ad300Position ? numHiddenLineups + 3 : ad300Position + 3;
            connatixAdSlot = Math.min(numVisibleLineups - 1, connatixAdSlot);
        }
        $(`.lineup:nth-child(${connatixAdSlot})`).after(`<div class="lineup is-ad is-connatix">${stnPlayerCode}</div>`);
    }

}

export default function insertSTNAds() {    
    const isLoggedInUser = $('.rwnav-top-account').length > 0;
    //if (isLoggedInUser) { return; }
    console.log('Loading STN ads');

    // ARTICLES
    if ($('.article__body').length > 0 && $('.article-preview-fader').length === 0) {
        const numParagraphs = $('.article__body > p').length;
        let adPlacement = 3;
        if (numParagraphs < adPlacement) { adPlacement = Math.max(numParagraphs - 1, 1); }
        $(`.article__body > p:nth-of-type(${adPlacement})`).after(`<p>${getSTNPlayerCode()}</p>`);
        return;
    }

    // LINEUPS
    if ($('.lineups').length > 0) {

        // Add ad as a lineup card
        // We have to watch for the toggle-tab event on the "Hide Games That Have Started" option for each sport because
        // it messes with the positioning of the ads
        const tabSets = [
            'lineups-nfl-hidestarted',
            'lineups-mlb-hidestarted',
            'lineups-nba-hidestarted',
            'lineups-nhl-hidestarted',
            'lineups-euro-hidestarted',
            'lineups-soccer-hidestarted',
            'lineups-cricket-hidestarted',
        ];
        const tabOptions = ['Yes', 'No'];
        const eventsToWatch = [];
        tabSets.forEach((ts) => {
            tabOptions.forEach((opt) => { eventsToWatch.push(`toggleTabLoaded:${ts}-${opt}`); });
        });
        const eventsToWatchString = eventsToWatch.join(' ');
        $(document).on(eventsToWatchString, (e, tabSettings) => { addLineupCardPlacements(); });
    }
}
